import {
  createReverseContext,
  ReverseContext,
} from "@repo/ui/components/Base/hooks/useReverseContext";

export interface SaveAllContextType {
  order: number;
  save(): void | Promise<void>;
}

export const SaveAllContext = createReverseContext<SaveAllContextType>();

export const runSaveAll = async (
  context: ReverseContext<SaveAllContextType>
) => {
  // sort save handlers by order (least to greatest)
  const callbacks = context.values().sort((a, b) => a.order - b.order);
  // call save methods in order
  for (const { save } of callbacks) await save();
};
